import { SITE } from "@/lib/site";
import teamImage from "@/assets/team-fpo.webp?w=480;720;987&format=webp&as=meta";
import { responsiveImage } from "@/lib/responsiveImage";
import { SplitSection } from "@/components/SplitSection";

const teamPhoto = responsiveImage(teamImage);

export function TeamSection() {
  return (
    <SplitSection
      id="team"
      image={teamPhoto}
      imageAlt="Three engineers around a workbench of automation hardware, one holding up a handheld controller"
      imageSide="right"
      title="Built by people who’ve built what’s next before"
      body="Somo’s founders bring decades of experience building and scaling products, platforms, and connected experiences, including work with Apple and Siri. Now they’re bringing that experience to hospitality, combining technology, design, and building systems to rethink what’s possible in the guest room."
      cta={{ label: "About Our Team", href: `${SITE}/about` }}
    />
  );
}
